<template>
  <h3>Шаг 5. Финансы</h3>
  <p>Общая информация о проекте</p>
  <div>
    <a-form class="form performer-project-form" layout="vertical">
      <performer-project-form-row class="bordered">
        <a-row>
          <a-col :span="12">
            <a-form-item name="budget" label="Общий объем финансирования">
              <a-input
                :value="TextAdapter.toFinancial(model.budget)"
                placeholder="Укажите сумму"
                disabled
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="budgetSource" label="Источник финансирования">
              <a-input
                v-model:value="model.budgetSource"
                placeholder="Укажите источник"
                disabled
              />
            </a-form-item>
          </a-col>
        </a-row>
      </performer-project-form-row>

      <div class="budget-stages">
        <template
          v-for="(item, index) in model.budgetStages"
          :key="`budget-stages-` + index"
        >
          <div>
            <h3>Этап {{ index + 1 }}</h3>
            <performer-project-form-row
              :show-available="false"
              class="bordered"
            >
              <a-row>
                <a-col :span="12">
                  <a-form-item name="paymentAmount" label="Размер поступления">
                    <a-input
                      :value="TextAdapter.toFinancial(item.paymentAmount)"
                      placeholder="Укажите сумму"
                      disabled
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item name="paymentDate" label="Дата финансирования">
                    <a-date-picker
                      v-model:value="item.paymentDate"
                      placeholder="Выберите дату"
                      :locale="locale"
                      disabled
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </performer-project-form-row>
          </div>
        </template>
      </div>

      <!-- -- -->
      <div>
        <performer-project-form-row
          :show-available="false"
          :offset-available="false"
        >
          <h3>Смета проекта</h3>
        </performer-project-form-row>
        <template
          v-for="(item, index) in model.budgetCosts"
          :key="`costs-` + index"
        >
          <performer-project-form-row>
            <a-row>
              <a-col :span="12">
                <a-form-item name="costType" label="Статья расхода">
                  <a-input
                    v-model:value="item.costType"
                    placeholder="Выберите статью расхода"
                    disabled
                  />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item name="costAmount" label="Сумма">
                  <a-input
                    :value="TextAdapter.toFinancial(item.costAmount)"
                    placeholder="Укажите сумму"
                    disabled
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </performer-project-form-row>
        </template>
      </div>
    </a-form>
  </div>
</template>

<script setup>
  import { onMounted, reactive, watch } from 'vue';
  import locale from 'ant-design-vue/es/date-picker/locale/ru_RU';
  import PerformerProjectFormRow from '../PerformerProjectFormRow.vue';
  import dayjs from 'dayjs';
  import { TextAdapter } from '@/adapters/text-adapter';

  const props = defineProps({
    project: {
      type: Object,
      require: true,
    },
  });

  const model = reactive({
    budget: null,
    budgetSource: null,
    budgetStages: [],
    budgetCosts: [],
  });

  onMounted(() => {
    props.project && fillModel();
  });

  watch(
    () => props.project,
    () => {
      props.project && fillModel();
    }
  );

  const fillModel = () => {
    try {
      model.budget = props.project.budget;
      model.budgetSource = props.project.budgetSource;
      model.budgetStages = props.project.budgetStages.map((stage, index) => {
        return {
          id: index + 1,
          paymentDate: dayjs(stage.paymentDate, 'YYYY-MM-DD'),
          paymentAmount: stage.paymentAmount,
        };
      });
      model.budgetCosts = props.project.budgetCosts.map((cost, index) => {
        return {
          id: index + 1,
          costType: cost.costType,
          costAmount: cost.costAmount,
        };
      });
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use './performer-project-form.scss';

  .budget-stages {
    :deep(.bordered):last-child {
      border-bottom: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }

  .performer-project-form-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    & > button {
      margin-left: 10px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
</style>
